export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-2-line' },
  { slug: 'korean', name: '韩漫下拉式', icon: 'ri-global-line' },
  { slug: 'japanese', name: '日漫下拉式', icon: 'ri-earth-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'action', name: '热血', icon: 'ri-fire-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'horror', name: '悬疑', icon: 'ri-ghost-line' },
  { slug: 'campus', name: '校园', icon: 'ri-book-open-line' },
  { slug: 'urban', name: '都市', icon: 'ri-building-line' },
];

export const comics = [
  {
    id: 1,
    title: '霸道总裁的秘密',
    author: '星辰漫画社',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20book%20cover%20with%20elegant%20couple%20in%20modern%20office%20setting%2C%20soft%20warm%20lighting%2C%20beautiful%20illustration%20art%20style%2C%20clean%20pastel%20background%2C%20romantic%20atmosphere%2C%20professional%20manhwa%20cover%20quality%2C%20subdued%20cream%20and%20rose%20tones&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: 'korean',
    tags: ['韩漫', '恋爱', '都市', '霸道总裁'],
    description: '平凡女孩林小月意外进入顶级企业实习，却不知公司总裁正是她高中时暗恋的学长。命运的齿轮再次转动，一段甜蜜又纠结的办公室恋情悄然展开。当真相揭开，她该如何面对这份跨越阶层的爱情？',
    status: '连载中',
    updateTime: '2026-08-04',
    rating: 9.5,
    views: '128.5万',
    chapters: Array.from({ length: 86 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话${i === 0 ? ' 命运的相遇' : i === 85 ? ' 新的开始' : ''}`,
      updateTime: `2026-${String(8 - Math.floor(i / 10)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 2,
    title: '剑与魔法纪元',
    author: '幻境工作室',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20fantasy%20manga%20cover%20with%20warrior%20holding%20glowing%20sword%20in%20magical%20world%2C%20dramatic%20lighting%2C%20epic%20fantasy%20illustration%20style%2C%20warm%20golden%20and%20amber%20tones%2C%20clean%20background%20with%20magical%20particles%2C%20professional%20manga%20cover%20quality&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: 'japanese',
    tags: ['日漫', '奇幻', '热血', '冒险'],
    description: '在魔法与科技并存的大陆上，少年剑士艾德踏上了寻找传说中「星之剑」的旅程。旅途中他结识了精灵法师、矮人铁匠和龙族后裔，一场改变世界命运的冒险就此展开！',
    status: '连载中',
    updateTime: '2026-08-03',
    rating: 9.7,
    views: '256.8万',
    chapters: Array.from({ length: 124 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话${i === 0 ? ' 启程之日' : ''}`,
      updateTime: `2026-${String(8 - Math.floor(i / 15)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 3,
    title: '甜蜜陷阱',
    author: '月光漫画',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20manhwa%20cover%20with%20sweet%20couple%20in%20cherry%20blossom%20park%2C%20soft%20pink%20and%20cream%20color%20palette%2C%20beautiful%20illustration%20style%2C%20gentle%20spring%20atmosphere%2C%20clean%20background%2C%20romantic%20watercolor%20texture%2C%20professional%20comic%20cover&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: 'korean',
    tags: ['韩漫', '恋爱', '校园'],
    description: '大学新生苏瑶瑶阴差阳错与校草顾辰签订了「假扮情侣」契约。本应是各取所需的交易，却在朝夕相处中萌生了真实的情感。当契约到期，他们是否还有勇气说出口？',
    status: '已完结',
    updateTime: '2026-07-28',
    rating: 9.3,
    views: '189.2万',
    chapters: Array.from({ length: 72 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateTime: '2026-07-28',
    })),
  },
  {
    id: 4,
    title: '暗夜猎人',
    author: '黑曜石漫画',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20urban%20fantasy%20manga%20cover%20with%20mysterious%20hunter%20in%20leather%20coat%20standing%20on%20rooftop%20at%20night%2C%20moody%20atmospheric%20lighting%2C%20noir%20illustration%20style%2C%20deep%20warm%20brown%20and%20crimson%20tones%2C%20clean%20background%2C%20professional%20comic%20cover&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: 'japanese',
    tags: ['日漫', '悬疑', '都市', '动作'],
    description: '在普通人类看不见的地方，暗夜猎人们默默守护着世界的平衡。高中生林澈意外觉醒了猎人之血，被迫卷入了一场关乎人类存亡的秘密战争。黑暗中的真相，远比想象中更加残酷。',
    status: '连载中',
    updateTime: '2026-08-02',
    rating: 9.4,
    views: '167.3万',
    chapters: Array.from({ length: 58 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateTime: `2026-${String(8 - Math.floor(i / 8)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 5,
    title: '爆笑校园日记',
    author: '哈哈漫画',
    cover: 'https://readdy.ai/api/search-image?query=Funny%20school%20comedy%20manhwa%20cover%20with%20exaggerated%20cartoon%20characters%20in%20classroom%2C%20bright%20and%20cheerful%20illustration%20style%2C%20warm%20yellow%20and%20cream%20tones%2C%20clean%20simple%20background%2C%20humorous%20comic%20cover%2C%20professional%20quality&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: 'comedy',
    tags: ['搞笑', '校园', '日常'],
    description: '普通高中二年级三班，一群性格迥异的学生和老师之间发生的爆笑日常。从考试作弊到食堂抢饭，从运动会到文化祭，每一页都能让你笑到肚子疼！',
    status: '连载中',
    updateTime: '2026-08-04',
    rating: 9.1,
    views: '312.6万',
    chapters: Array.from({ length: 156 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateTime: `2026-${String(8 - Math.floor(i / 20)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 6,
    title: '仙尊归来',
    author: '九霄漫画',
    cover: 'https://readdy.ai/api/search-image?query=Cultivation%20fantasy%20manhua%20cover%20with%20powerful%20immortal%20in%20flowing%20white%20robe%20amidst%20clouds%20and%20mountains%2C%20ethereal%20illustration%20style%2C%20soft%20golden%20and%20jade%20green%20tones%2C%20clean%20celestial%20background%2C%20professional%20comic%20cover%20quality&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: 'fantasy',
    tags: ['奇幻', '修仙', '热血'],
    description: '一代仙尊渡劫失败，灵魂穿越回千年之前的地球。带着前世记忆和修仙功法，他要在现代都市中重新踏上修仙之路。昔日仇敌，今朝清算；前世遗憾，今生弥补！',
    status: '连载中',
    updateTime: '2026-08-03',
    rating: 9.6,
    views: '445.1万',
    chapters: Array.from({ length: 203 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateTime: `2026-${String(8 - Math.floor(i / 25)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 7,
    title: '深夜怪谈社',
    author: '鬼灯漫画',
    cover: 'https://readdy.ai/api/search-image?query=Horror%20mystery%20manga%20cover%20with%20group%20of%20students%20holding%20flashlights%20in%20dark%20school%20corridor%2C%20eerie%20atmospheric%20illustration%2C%20deep%20shadow%20and%20warm%20lantern%20light%20tones%2C%20clean%20dark%20background%2C%20professional%20comic%20cover&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: 'horror',
    tags: ['悬疑', '恐怖', '校园'],
    description: '每个深夜，学校旧校舍三楼的社团活动室里都会亮起微弱的灯光。五个学生组成了「深夜怪谈社」，调查校园里流传的诡异传说。然而，当他们越接近真相，危险也离他们越来越近……',
    status: '连载中',
    updateTime: '2026-08-01',
    rating: 9.0,
    views: '98.7万',
    chapters: Array.from({ length: 42 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateTime: `2026-${String(8 - Math.floor(i / 6)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 8,
    title: '都市灵异事件簿',
    author: '墨渊工作室',
    cover: 'https://readdy.ai/api/search-image?query=Urban%20supernatural%20manga%20cover%20with%20detective%20character%20investigating%20mysterious%20occurrence%20in%20modern%20city%20at%20twilight%2C%20noir%20illustration%20style%2C%20warm%20amber%20streetlight%20and%20dark%20blue%20night%20tones%2C%20clean%20background%2C%20professional%20comic%20cover&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: 'urban',
    tags: ['都市', '悬疑', '灵异'],
    description: '刑警队长方明在处理一连串离奇案件时，发现所有的线索都指向了一个超自然的存在。科学与玄学的边界在这座城市中变得模糊不清。',
    status: '已完结',
    updateTime: '2026-06-15',
    rating: 8.9,
    views: '134.5万',
    chapters: Array.from({ length: 64 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateTime: '2026-06-15',
    })),
  },
  {
    id: 9,
    title: '热血篮球少年',
    author: '极速漫画',
    cover: 'https://readdy.ai/api/search-image?query=Sports%20action%20manga%20cover%20with%20teenage%20basketball%20player%20jumping%20for%20dunk%20in%20gymnasium%2C%20dynamic%20illustration%20style%2C%20warm%20court%20lighting%20and%20orange%20tones%2C%20clean%20background%2C%20professional%20comic%20cover%2C%20energetic%20atmosphere&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    category: 'action',
    tags: ['热血', '运动', '校园'],
    description: '身高只有168cm的林小川梦想成为全国最强的控球后卫。进入高中后，他遇到了各具特色的队友和强大的对手。在这片热血的球场上，属于他们的青春故事正在上演！',
    status: '连载中',
    updateTime: '2026-08-04',
    rating: 9.5,
    views: '278.3万',
    chapters: Array.from({ length: 112 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateTime: `2026-${String(8 - Math.floor(i / 14)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 10,
    title: '重生之商业帝国',
    author: '青云漫画',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20business%20manhwa%20cover%20with%20confident%20CEO%20in%20luxury%20office%20overlooking%20city%20skyline%2C%20sleek%20illustration%20style%2C%20warm%20golden%20sunset%20and%20cream%20tones%2C%20clean%20modern%20background%2C%20professional%20comic%20cover&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    category: 'urban',
    tags: ['都市', '重生', '商战'],
    description: '顶级投资人陈远在事业巅峰时遭到背叛，含恨而终。意外重生回到大学时代，带着前世所有记忆，他决定改写自己的命运。这一次，他不仅要打造属于自己的商业帝国，更要让那些背叛者付出代价！',
    status: '连载中',
    updateTime: '2026-08-02',
    rating: 9.2,
    views: '198.4万',
    chapters: Array.from({ length: 95 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateTime: `2026-${String(8 - Math.floor(i / 12)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 11,
    title: '魔法学院优等生',
    author: '星辰大海',
    cover: 'https://readdy.ai/api/search-image?query=Fantasy%20school%20manga%20cover%20with%20students%20in%20magic%20academy%20uniforms%20casting%20spells%20in%20grand%20hall%2C%20enchanting%20illustration%20style%2C%20warm%20candlelight%20and%20golden%20tones%2C%20clean%20magical%20background%2C%20professional%20comic%20cover&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    category: 'fantasy',
    tags: ['奇幻', '校园', '魔法'],
    description: '出身普通家庭的路易斯被世界顶级的魔法学院录取，却发现自己在魔法天赋上远远落后于贵族同学们。凭借过人的智慧和勤奋，他一步步证明：天赋决定起点，但努力决定终点！',
    status: '连载中',
    updateTime: '2026-07-30',
    rating: 9.3,
    views: '156.7万',
    chapters: Array.from({ length: 68 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateTime: `2026-${String(8 - Math.floor(i / 10)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 12,
    title: '恋爱补给品',
    author: '甜蜜工坊',
    cover: 'https://readdy.ai/api/search-image?query=Slice%20of%20life%20romance%20manhwa%20cover%20with%20young%20couple%20sharing%20earphones%20in%20cozy%20cafe%2C%20warm%20and%20gentle%20illustration%20style%2C%20soft%20coral%20and%20cream%20tones%2C%20clean%20background%2C%20professional%20comic%20cover%2C%20comforting%20atmosphere&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    category: 'romance',
    tags: ['恋爱', '日常', '治愈'],
    description: '社恐女孩周小暖和阳光大男孩沈渡因为一只流浪猫而相识。在温柔的日常相处中，两颗孤独的心慢慢靠近。恋爱就像补给品，不需要轰轰烈烈，只需要恰到好处的温暖。',
    status: '连载中',
    updateTime: '2026-08-04',
    rating: 9.4,
    views: '145.9万',
    chapters: Array.from({ length: 38 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateTime: `2026-${String(8 - Math.floor(i / 5)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
];

export const hotComics = comics.sort((a, b) => b.views - a.views).slice(0, 6);

export const latestUpdates = [...comics].sort((a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime()).slice(0, 8);

export const testimonials = [
  {
    id: 1,
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20portrait%20with%20friendly%20smile%2C%20casual%20style%2C%20warm%20lighting%2C%20clean%20cream%20background%2C%20professional%20headshot%20quality&width=80&height=80&seq=avatar-01&orientation=squarish',
    content: '43423漫画网的下拉式阅读体验真的太棒了！再也不用一页一页翻，手指轻轻一滑就能连续看，追更效率直接翻倍。韩漫资源也很丰富，强烈推荐！',
    rating: 5,
  },
  {
    id: 2,
    name: '二次元少女',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20with%20gentle%20smile%2C%20modern%20style%2C%20soft%20warm%20lighting%2C%20clean%20cream%20background%2C%20professional%20headshot%20quality&width=80&height=80&seq=avatar-02&orientation=squarish',
    content: '在这里追了好多日漫和韩漫，更新速度很快，画质也清晰。最喜欢的还是下拉式浏览方式，躺在床上单手操作毫无压力，简直是为懒人量身定做的！',
    rating: 5,
  },
  {
    id: 3,
    name: '深夜党老张',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Asian%20man%20portrait%20with%20warm%20expression%2C%20clean%20casual%20look%2C%20soft%20studio%20lighting%2C%20clean%20cream%20background%2C%20professional%20headshot%20quality&width=80&height=80&seq=avatar-03&orientation=squarish',
    content: '作为一个看了十几年漫画的老读者，43423漫画网的下拉式设计让我眼前一亮。分类很全，悬疑和热血类的漫画特别对胃口。每天睡前必刷，已经成为习惯了。',
    rating: 4,
  },
  {
    id: 4,
    name: '学生党小林',
    avatar: 'https://readdy.ai/api/search-image?query=Teenage%20Asian%20student%20portrait%20with%20bright%20smile%2C%20youthful%20style%2C%20natural%20warm%20lighting%2C%20clean%20cream%20background%2C%20professional%20headshot%20quality&width=80&height=80&seq=avatar-04&orientation=squarish',
    content: '放学回家第一件事就是打开43423漫画网看看更新了没！下拉式阅读的好处就是看起来特别爽，连贯性超强。已经把整个宿舍都安利过来一起看啦！',
    rating: 5,
  },
  {
    id: 5,
    name: '上班族阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20professional%20man%20portrait%20with%20confident%20look%2C%20business%20casual%20style%2C%20warm%20office%20lighting%2C%20clean%20cream%20background%2C%20professional%20headshot%20quality&width=80&height=80&seq=avatar-05&orientation=squarish',
    content: '通勤路上用手机看漫画的最佳选择！下拉式设计在手机上体验特别好，不像传统翻页那样麻烦。漫画种类也全，恋爱、热血、奇幻各类型都有。',
    rating: 5,
  },
  {
    id: 6,
    name: '漫画达人小雨',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20with%20playful%20expression%2C%20trendy%20style%2C%20warm%20natural%20lighting%2C%20clean%20cream%20background%2C%20professional%20headshot%20quality&width=80&height=80&seq=avatar-06&orientation=squarish',
    content: '对比过很多漫画平台，43423漫画网的下拉式阅读流畅度是最高的。页面加载快，广告少，阅读体验纯净。收藏夹里的漫画已经快放不下了！',
    rating: 5,
  },
];